import RoleNavigation from "./RoleNavigation";
export default function PlatformAdminNav() {
  return <RoleNavigation role="platform_admin" />;
}
